<!-- eslint-disable vue/multi-word-component-names -->

<script>
import TerminehMixin from '@/Mixins/800/termineh.mixin';
import SharedMixin from '@/Mixins/Shared';
export default {
  inject: ['load'],
  mixins: [TerminehMixin, SharedMixin],
  props: {
    isModalOpen: {
      default: false,
      required: true,
      type: Boolean,
    },
    missionId: {
      default: null,
      required: true,
      type: [Number, null],
    },
    allUniversitiesList: {
      type: [],
      required: true,
      default: [],
    },
  },
  methods: {
    onSubmit: function () {
      const onSuccess = () => {
        this.resetTerminehForm();
        this.$emit('on-success');
      };
      this.creatingFormBody.missionId = this.missionId;
      this.createNewTermineh(onSuccess);
    },
    resetTerminehForm: function () {
      this.$emit('close-modal');
      this.creatingFormBody = {
        missionId: null,
        emergencyMedicalCenterId: null,
      };
    },
  },
};
</script>
<template lang="html">
  <v-dialog :value="isModalOpen" width="350" persistent>
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" class="modal-header py-2">
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-icon color="darkColor">mdi-email-arrow-right mdi-18px</v-icon>
            <span class="modal-title-text ml-n11">ترمینه</span>
            <v-spacer></v-spacer>
            <v-icon class="ml-3" @click="$emit('close-modal')">mdi-close</v-icon>
          </v-row>
        </v-col>
      </v-row>
      <v-card-text class="py-2">
        <v-row no-gutters>
          <v-autocomplete hide-details :items="allUniversitiesList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
            item-text="title" item-value="id" label="مرکز" clearable clear-icon="mdi-close-circle-outline"
            v-model="creatingFormBody.emergencyMedicalCenterId" autocomplete="off"
            prepend-inner-icon="mdi-subtitles mdi-18px"></v-autocomplete>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="onSubmit()" dark rounded class="normal-letter-spacing px-12 ml-5">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="$emit('close-modal')" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="css"></style>
